import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight, Check } from "lucide-react";
import { api } from "../lib/api";

export default function SubscribeForm({ id = "subscribe", large = false }) {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setState("loading");
    try {
      const { data } = await api.post("/subscribe", { email });
      setState("done");
      toast(data?.status === "already_subscribed" ? "You are already on the list." : "You are in. Check your inbox.");
    } catch (err) {
      setState("idle");
      toast(err?.response?.status === 422 ? "That address does not look right." : "Something broke. Try again.");
    }
  };

  if (state === "done") {
    return (
      <div className="flex items-center gap-4 border-b border-[var(--bone)] py-5" data-testid={`${id}-success`}>
        <Check size={20} className="text-[var(--signal)]" />
        <p className="f-serif italic text-xl sm:text-2xl">You are in. Proceed accordingly.</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="group flex items-end gap-4 border-b border-[var(--bone)] focus-within:border-[var(--signal)] transition-colors duration-500" data-testid={`${id}-form`}>
      <label className="flex-1">
        <span className="sr-only">Email address</span>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your@address"
          className={`w-full bg-transparent outline-none py-4 f-serif italic placeholder:text-[#7d7d77] ${large ? "text-3xl sm:text-5xl" : "text-2xl sm:text-3xl"}`}
          data-testid={`${id}-email-input`}
        />
      </label>
      <button
        type="submit"
        disabled={state === "loading"}
        className="f-mono text-xs uppercase tracking-[0.2em] pb-5 flex items-center gap-2 hover:text-[var(--signal)] transition-colors duration-300 disabled:opacity-50"
        data-testid={`${id}-submit-button`}
      >
        {state === "loading" ? "Sending" : "Begin"}
        <ArrowRight size={16} className="transition-transform duration-500 group-hover:translate-x-1" />
      </button>
    </form>
  );
}
